import React, { useCallback, useEffect, useState, useContext, ChangeEvent } from 'react';
import { FaSave } from 'react-icons/fa';
import { FiEdit2, FiSave, FiTrash2, FiX } from 'react-icons/fi';
import Numbers from '~/utils/numbers';
import Dates from '~/utils/dates';
import sort_by from '~/utils/sort';
import funcs from '~/utils/funcs';
import './styles.css';

// Contexts
import { GeneralContext, ModalContext } from '~/contexts';
import { UnitsContext } from '~/contexts/forms/units';

// Components
import CurrencyInput from '~/components/Modules/CurrencyMask';
import api from '~/services/api';

const Form: React.FC<any> = ({ unit, others, setReady }) => {
    const [othersData, setOthersData] = useState<any[]>([]);
    const [othersV, setOthersV]       = useState<any>();
    const [othersPO, setOthersPO]     = useState<any>();

    // Contexts
    const { user } = useContext(GeneralContext);
    const Units = useContext(UnitsContext);
    const Modal = useContext(ModalContext);

    const unitId = unit?.id ?? unit;

    function onChange(event: ChangeEvent<HTMLInputElement | HTMLSelectElement>) {
        const {name, value} = event.target;
        let newData = JSON.parse(JSON.stringify(othersV))
        let data    = funcs.onChange(newData, name, value);
        setOthersV(data);
    }

    function onChangeFloat(event: ChangeEvent<HTMLInputElement | HTMLSelectElement>, originalValue: any) {
        let {name}  = event.target;
        let newData = JSON.parse(JSON.stringify(othersV))
        let data    = funcs.onChangeFloat(newData, name, originalValue);
        setOthersV(data);
    }

    function formatPrice (value: string | number) {
        if (typeof value==='undefined') return '';
        else if (typeof value==='string') return Numbers.money(parseFloat(value.replace('.', '').replace(',', '.')), false, true);
        return Numbers.money(value, false, true);
    }

    function getMonths () {
        let ret: any = [];

        for (let i=0; i<=11; i++) {
            let item = {
                month: i+1,
                name: Dates._getNameMonth(i)
            };

            ret.push(item);
        }

        return ret;
    }

    function getYears () {
        let init = Number(Dates.getYear()),
            ret: any = [];

        for (let i=init; i>=(init-20); i--) {
            ret.push(i);
        }

        return ret;
    }

    function getMonthName(month: number) {
        month = Number(month);
        if (month===0) return 'Geral';
        return Dates._getNameMonth((month-1));
    }

    function addOthers(index: number) {
        let date  = new Date();
        let data  = { unit_id: unitId, year: date.getFullYear(), month: (date.getMonth() + 1), cative: 0.0, freeMarket: 0.0, index };
        let datas = JSON.parse(JSON.stringify(othersData));

        // Add Item
        datas.push(data);
       // datas.sort(sort_by({name: 'year', reverse: true}, {name: 'month'}));

        // Set new items
        setOthersData(datas);
    }

    function editOthers(elem: any, index: number) {
        let item = document.querySelector(`div[data-rel="${elem.unit_id}_${elem.year}_${elem.month}_${index}"]`);
        item?.classList.add('active');

        setOthersV(elem);
        setOthersPO(elem);
    }

    function deleteOthers(elem: any) {
        let datas = JSON.parse(JSON.stringify(othersData));
        let idx = datas.findIndex((q: any) => q.year===elem.year && q.month===elem.month && q.unit_id===elem.unit_id);

        // Remove Item
        datas.splice(idx, 1);
        //datas.sort(sort_by({name: 'year', reverse: true}, {name: 'month'}));

        // Set new items
        setOthersData(datas);
    }

    function saveOthers(elem: any, index: number) {
        let datas = JSON.parse(JSON.stringify(othersData));
        let item  = document.querySelector(`div[data-rel="${elem.unit_id}_${elem.year}_${elem.month}_${index}"]`);
        item?.classList.remove('active');

        // Change Item
        let idx = datas.findIndex((q: any) => q.year===othersPO.year && q.month===othersPO.month && q.unit_id===othersPO.unit_id && q.index===index);
        datas.splice(idx, 1, othersV);
        //datas.sort(sort_by({name: 'year', reverse: true}, {name: 'month'}));

        // Set new items
        setOthersData(datas);

        // Clear Data Items
        setOthersV(null);
        setOthersPO(null);
    }

    function cancelOthers(elem: any, index: number) {
        let item = document.querySelector(`div[data-rel="${elem.unit_id}_${elem.year}_${elem.month}_${index}"]`);
        item?.classList.remove('active');
        setOthersV(null);
    }

    const getData = useCallback(async () => {
        if (!unitId) {
            setOthersData([]);
            return;
        }
        await api.get(`/clients/others/${unitId}`, {
            headers: { Authorization: user.token }
        }).then((resp: any) => {
            const arr = Array.isArray(resp?.data) ? [...resp.data] : [];
            const sorted = arr.length > 0 ? arr.sort(sort_by({ name: 'year', reverse: true }, { name: 'month' })) : [];
            setOthersData(sorted.map((el: any, index: number) => ({ ...el, index })));
            setOthersV(null);
            setOthersPO(null);
        }).catch(err => {
            console.error("Erro ao carregar outros valores:", err);
        });
    }, [unitId, user.token]);

    useEffect(() => {
        // Se o pai já trouxe `others`, usamos como “preload” e ainda assim buscamos o dado mais atual no backend
        const othersArr = Array.isArray(others) ? [...others] : [];
        if (othersArr.length > 0) {
            const sorted = othersArr.sort(sort_by({ name: 'year', reverse: true }, { name: 'month' }));
            setOthersData(sorted.map((el: any, index: number) => ({ ...el, index })));
        }
        getData();
    }, [others, unitId, getData]);

    return (
        <>
            {
                othersData.length>0 ? (
                    <div className="header">
                        <div className="infos">
                            <div className="year">Ano</div>
                            <div className="month">Mês</div>
                            <div className="cative">Cativo</div>
                            <div className="freeMarket">Mercado Livre</div>
                        </div>

                        <div className="buttons"></div>
                    </div>
                ) : <></>
            }

            {
                othersData.map((el: any, index: number) => (
                    <div className="line" key={`${el.unit_id}_${el.year}_${el.month}_${othersData.length - index - 1}`} data-rel={`${el.unit_id}_${el.year}_${el.month}_${index}`}>
                        <div className="infos">
                            <div className="item">
                                <div className="year">{ el.year }</div>
                                <div className="month">{ getMonthName(el.month) }</div>
                                <div className="cative">R$ { formatPrice(el.cative ? el.cative : '0.00') }</div>
                                <div className="freeMarket">R$ { formatPrice(el.freeMarket ? el.freeMarket : '0.00') }</div>
                            </div>

                            <div className="edit">
                                <div className="year">
                                    <select name="year" id="year" onChange={onChange} defaultValue={othersV?.year}>
                                        {
                                            getYears().map((ye: any) => (
                                                <option key={`key_${ye}`} value={ye}>{ye}</option>
                                            ))
                                        }
                                    </select>
                                </div>

                                <div className="month">
                                    <select
                                        name="month" id="month" onChange={onChange}
                                        defaultValue={el.month ? el.month : '0'}
                                    >
                                        <option value="0">Geral</option>

                                        <optgroup label="Meses">
                                            {
                                                getMonths().map((mo: any) => (
                                                    <option key={`month_${mo.name}`} value={mo.month}>{mo.name}</option>
                                                ))
                                            }
                                        </optgroup>
                                    </select>
                                </div>

                                <div className="cative">
                                    <CurrencyInput
                                        id="cative" name="cative" placeholder="0,00"
                                        onChangeValue={onChangeFloat}
                                        value={othersV?.cative}
                                        hideSymbol
                                    />
                                </div>

                                <div className="freeMarket">
                                    <CurrencyInput
                                        id="freeMarket" name="freeMarket" placeholder="0,00"
                                        onChangeValue={onChangeFloat}
                                        value={othersV?.freeMarket}
                                        hideSymbol
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="buttons">
                            <div className="item">
                                <button className="edit" onClick={() => editOthers(el, index)} disabled={(!othersV ? false : true)}>
                                    <FiEdit2 size={16} />
                                </button>

                                <button className="del" onClick={() => deleteOthers(el)} disabled={(!othersV ? false : true)}>
                                    <FiTrash2 size={16} />
                                </button>
                            </div>

                            <div className="edit">
                                <button className="save" onClick={() => saveOthers(el, index)}>
                                    <FiSave size={16} />
                                </button>

                                <button className="cancel" onClick={() => cancelOthers(el, index)}>
                                    <FiX size={16} />
                                </button>
                            </div>
                        </div>
                    </div>
                ))
            }

            <div className="footerBottons">
                <button className="btn add" onClick={() => addOthers(othersData.length)}>Adicionar outro valor</button>
                <button className="btn save" onClick={() => Units.saveOthers(unitId, othersData, Modal, setReady)}><FaSave /></button>
            </div>
        </>
    )
}

export default Form;